<script lang="ts" setup>
import {router} from '@inertiajs/vue3';
import {route} from 'ziggy-js';

interface Props {
  active: 'buy' | 'free' | 'purchases';
}

const props = defineProps<Props>();

const openPurchases = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('roblox:open-purchases'));
  }
};
</script>

<template>
  <div class="relative">
    <div class="bg-deep-blue overflow-auto rounded-lg px-1.5 py-0.5 gap-2 flex justify-between without-scrollbars">
    <button
      @click="router.get(route('roblox.index'))"
      :class="[props.active === 'buy' && 'bg-sky-600']"
      class="py-1.5 rounded-lg min-w-fit px-1 flex shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] items-center gap-1"
    >
      <span class="shrink-0">
        <img src="/assets/img/roblox/tab-1.svg" alt="tab-1" />
      </span>
      <span class="font-sans whitespace-nowrap font-medium text-sky-200 text-base">
        {{ $t('Buy Robux') }}
      </span>
    </button>

    <button
      @click="router.get(route('roblox.free'))"
      :class="[props.active === 'free' && 'bg-sky-600']"
      class="py-1.5 rounded-lg px-1 min-w-fit shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] flex items-center gap-1"
    >
      <span class="shrink-0">
        <img src="/assets/img/roblox/tab-2.svg" alt="tab-2" />
      </span>
      <span class="font-sans  whitespace-nowrap font-medium text-sky-200 text-base">
        {{ $t('Free') }}
      </span>
    </button>

    <button
      @click="openPurchases"
      :class="[props.active === 'purchases' && 'bg-sky-600']"
      class="py-1.5 rounded-lg px-1 min-w-fit shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] flex items-center gap-1"
    >
      <span class="shrink-0">
        <img src="/assets/img/roblox/tab-3.svg" alt="tab-3" />
      </span>
      <span class="font-sans  whitespace-nowrap font-medium text-sky-200 text-base">
        {{ $t('My purchases') }}
      </span>
    </button>
    </div>
    <!-- The scrollbar is deliberately hidden (.without-scrollbars) on a row that genuinely
         overflows on narrow viewports (3 tabs don't fit at 390px), so without this there was no
         visual hint at all that "Мои покупки" continues past the edge - just a hard word-cut. -->
    <div class="pointer-events-none absolute right-0 inset-y-0 w-6 bg-gradient-to-l from-deep-blue to-transparent rounded-r-lg"></div>
  </div>
</template>
<style lang="css">
.without-scrollbars::-webkit-scrollbar{
    display: none;
}

.without-scrollbars{
    scrollbar-width: none;
    -ms-overflow-style: none;
}
</style>
